import { render } from "./AlphaGoat03.vue?vue&type=template&id=35a92a6f&scoped=true"
const script = {}

import "./AlphaGoat03.vue?vue&type=style&index=0&id=35a92a6f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a92a6f"]])

export default __exports__